import React, {Component} from 'react';
import API from "../../services/API";
import Loading from "../Common/Loading";
import Toast from "../Common/Toast";
import {toast} from "react-toastify";
import Actionbar from "../Common/Actionbar";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faAngleDown,
     faAngleUp, faClock,

} from "@fortawesome/free-solid-svg-icons";

const currencyFormat = Intl.NumberFormat('en-US');
class ManageWallet extends Component {
    state = {
        transactions : [],
        charge : 0,
        decharge : 0,
        description : ''
    }
    onInputChange = (event) => {

        this.setState({[event.target.name] : event.target.value});
    }
    onChargeClick = (is_charge) => {
        if(is_charge && this.state.charge < 1) {
            toast.error('لطفا مبلغ افزایش را درست وارد کنید');
            return false;
        }
        if(!is_charge && this.state.decharge < 1) {
            toast.error('لطفا مبلغ کاهش را درست وارد کنید')
            return false;
        }
        if(this.state.description.length < 5) {
            toast.error('لطفا توضیحات مربوطه را درست وارد کنید')
            return false;
        }
        const request = {
            charge : is_charge ? this.state.charge : 0,
            decharge : is_charge ?  0 : this.state.decharge ,
            description : this.state.description,
            id:this.props.match.params.id
        }
        this.setState({isLoaded: false})
        API.charge(request)
            .then((response) => {
                API.getWalletDetaild(request)
                    .then((response) => {
                        this.setState(response.results)
                        this.setState({isLoaded: true , charge : 0 , decharge: 0, description: ''})

                        setTimeout (() => {
                            window.scrollTo({top: 0, behavior: 'smooth'});
                        },400)

                    })

                setTimeout (() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                },400)

            })
            .catch((error) => {
                this.setState({isLoaded: true})
                   toast.error(error.response.data.user_message);

            });
    }
    render() {
        return (
            <React.Fragment>
                {!this.state.isLoaded ? <Loading/> :''}
                <Toast/>
                <Actionbar noBack={0} title='کیف پول  '/>
                <section className="container p-4 rtl my-5">
                    <div className="row my-3 alert alert-success text-center super-small ">
                        <div className="col-12 fw-bold border-bottom border-white mb-3 pb-2">
                            اطلاعات کیف پول:
                            &nbsp;
                            {this.state.full_name}
                        </div>
                        <div className="col-6 fw-bold ">
                            موجودی کیف پول
                        </div>
                        <div className="col-6 fw-bold">
                            {currencyFormat.format(this.state.wallet_inventory)}
                            &nbsp;
                            ریال
                        </div>
                    </div>
                    <div className="row mt-2 bg-dark bg-opacity-25 p-3 rounded">
                        <div className="col-12">
                            <div className="form-floating">
                                <textarea className="form-control super-small" placeholder="توضیحات"
                                          name='description'
                                          value={this.state.description}
                                          onChange={this.onInputChange}
                                          id="floatingTextarea" />
                                <label htmlFor="floatingTextarea" className='super-small'>توضیحات مربوط به افزایش یا کاهش کیف پول</label>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-5">
                        <div className="col-12 pb-2 super-small-2 fw-bold border-bottom text-success ">
                            افزایش موجودی
                            <span className='float-left text-secondary small'>
                                مجموع افزایش ها:
                                &nbsp;
                                {currencyFormat.format(this.state.wallet_increase_total)}
                                &nbsp;
                                ریال
                            </span>
                        </div>
                        <div className="col-6 mt-2 pt-2">
                            <div className="form-floating  ">
                                <input type="tel" className="form-control w-100 text-center" id="floatingInput"
                                       name='charge'
                                       value={this.state.charge}
                                       onChange={this.onInputChange}
                                />
                                <label htmlFor="floatingInput" className='small'>مبلغ شارژ (ریال)</label>
                            </div>
                        </div>
                        <div className="col-6 mt-2 pt-4">
                            <button className='btn btn-success w-100'
                            onClick={() => {
                                this.onChargeClick(1)
                            }}
                            >
                                شارژ
                                                        &nbsp;
                                {currencyFormat.format(this.state.charge / 10)}
                                &nbsp;
                                تومان
                            </button>
                        </div>
                    </div>

                    <div className="row mt-5 pb-2 ">
                        <div className="col-12 pb-2 super-small-2 fw-bold border-bottom text-danger ">
                            کاهش موجودی
                            <span className='float-left text-secondary small'>
                                مجموع کاهش ها:
                                &nbsp;
                                {currencyFormat.format(this.state.wallet_decrease_total)}
                                &nbsp;
                                ریال
                            </span>
                        </div>
                        <div className="col-6 mt-2 pt-2">
                            <div className="form-floating  ">
                                <input type="tel" className="form-control w-100 text-center" id="floatingInput"
                                       name='decharge'
                                       value={this.state.decharge}
                                       onChange={this.onInputChange}
                                />
                                <label htmlFor="floatingInput" className='small'>مبلغ کسر (ریال)</label>
                            </div>
                        </div>
                        <div className="col-6 mt-2 pt-4">
                            <button className='btn btn-danger w-100'
                                    onClick={() => {
                                        this.onChargeClick(0)
                                    }}
                            >
                                کسر
                                &nbsp;
                                {currencyFormat.format(this.state.decharge / 10)}
                                &nbsp;
                                تومان
                            </button>
                        </div>
                    </div>


                    <div className="row mt-5">
                        <div className="col-12 pb-2 super-small-2 fw-bold border-bottom text-primary">
                           آخرین تراکنش ها
                                        </div>
                        <div className="col-12">
                            <div className="earn-money-transactions px-3">
                                {
                                    this.state.transactions.map(transaction=> {
                                        if(transaction.decrease_amount > 0) {
                                            return(
                                                <div className="row earn-money-transaction " key={transaction.id}>
                                                    <div className="col-7">
                                                        <div className="transaction-title text-danger">
                                                            {transaction.description}
                                                        </div>
                                                        <div className="transaction-description">
                                                            <FontAwesomeIcon icon={faClock}  className='ms-2' />
                                                            {transaction.created_at}
                                                        </div>
                                                    </div>
                                                    <div className="col-5">
                                                        <div className="transaction-amount">
                                                            <FontAwesomeIcon icon={faAngleDown} className="text-danger"/>
                                                            &nbsp;
                                                            {currencyFormat.format(
                                                                transaction.decrease_amount
                                                            ) }

                                                            &nbsp;
                                                            <small>{window.localStorage.getItem("currency_unit")}</small>
                                                        </div>
                                                        <div className="transaction-date">

                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        else {
                                            return(
                                                <div className="row earn-money-transaction " key={transaction.id}>
                                                    <div className="col-7">
                                                        <div className="transaction-title text-success">
                                                            {transaction.description}
                                                        </div>
                                                        <div className="transaction-description">
                                                            <FontAwesomeIcon icon={faClock}  className='ms-2' />
                                                            {transaction.created_at}

                                                        </div>
                                                    </div>
                                                    <div className="col-5">
                                                        <div className="transaction-amount">
                                                            <FontAwesomeIcon icon={faAngleUp} className="text-success"/>
                                                            &nbsp;
                                                            {currencyFormat.format(
                                                                transaction.increase_amount
                                                            ) }

                                                            &nbsp;
                                                            <small>{window.localStorage.getItem("currency_unit")}</small>
                                                        </div>
                                                        <div className="transaction-date">

                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }

                                    })
                                }
                            </div>
                        </div>

                    </div>

                </section>

            </React.Fragment>
        );
    }
    componentDidMount() {
        const request = {
            id : this.props.match.params.id
        }
        API.getWalletDetaild(request)
            .then((response) => {
                this.setState(response.results)
                this.setState({isLoaded: true})

                setTimeout (() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                },400)

            })
            .catch((error) => {
                //   toast.error(error.response.data.user_message);
            });
    }
}

export default ManageWallet;